import React, { Component } from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LayoutIcon, MousePointerClickIcon, SmartphoneIcon, CheckCircle2Icon } from 'lucide-react';
type ComponentType<T = {}> = ComponentType<T>;
type PillarCardProps = {
  number: string;
  icon: ComponentType<any>;
  title: string;
  items: string[];
};
const PillarCard: React.FC<PillarCardProps> = ({
  number,
  icon: Icon,
  title,
  items
}) => <div className="glass-card p-5 sm:p-8 flex flex-col h-full relative overflow-hidden group" data-id="element-219">
    <div className="absolute -top-4 sm:-top-6 -right-4 sm:-right-6 text-7xl sm:text-9xl font-heading font-extrabold text-slate-900/5 select-none" data-id="element-220">
      {number}
    </div>

    <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-gold-500/15 flex items-center justify-center mb-4 sm:mb-6 border border-gold-500/30 relative z-10" data-id="element-221">
      <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-gold-600" data-id="element-222" />
    </div>

    <h3 className="text-lg sm:text-2xl font-bold text-slate-900 mb-3 sm:mb-6 relative z-10" data-id="element-223">
      {title}
    </h3>

    <ul className="space-y-2 sm:space-y-4 relative z-10 flex-1" data-id="element-224">
      {items.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-225">
          <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 shrink-0 mt-0.5" data-id="element-226" />
          <span className="text-xs sm:text-base text-slate-600 leading-relaxed" data-id="element-227">
            {item}
          </span>
        </li>)}
    </ul>
  </div>;
export function GrowthStrategy() {
  return <SlideLayout data-id="element-228">
      <div className="mb-6 sm:mb-12 text-center" data-id="element-229">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full mx-auto" data-id="element-230" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-231">
          Recommended Solutions
        </h2>
        <p className="text-sm sm:text-xl text-slate-500 max-w-2xl mx-auto" data-id="element-232">
          A three-pillar approach to transform your website into a lead
          generation engine.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 items-stretch" data-id="element-233">
        <PillarCard number="01" icon={LayoutIcon} title="Page Structure (SEO + Revenue)" items={['Create dedicated service pages for each mortgage service (First Time Mortgages, Refinancing, Reverse Mortgages, Renewals)', 'Build location-specific landing pages (e.g., First Time Mortgages in Victoria, Refinancing in Edmonton)', 'Map high-intent keywords to specific pages, guiding users to the most relevant content', 'Redesign navigation around user intent and conversion paths']} data-id="element-234" />
        <PillarCard number="02" icon={MousePointerClickIcon} title="CRO & UX Optimization" items={['Redesign website navigation — highlight "Apply Now," "Get Pre-Approved," and "Book a Consultation"', 'Implement conversion-focused CTAs: "Get a Quote," "Apply Now," "Speak to a Mortgage Specialist"', 'Optimize page layouts with lead-generating forms, trust signals, and above-the-fold contact options', 'Add social proof, testimonials, and trust indicators throughout']} data-id="element-235" />
        <PillarCard number="03" icon={SmartphoneIcon} title="Mobile & Performance" items={['Focus on mobile optimization for speed and ease of navigation (currently 61/100)', 'Reduce bounce rates by improving mobile load times significantly', 'Ensure CTAs are accessible and prominent on mobile devices', 'Improve Core Web Vitals for better search rankings']} data-id="element-236" />
      </div>

      <p className="mt-4 sm:mt-8 text-xs sm:text-sm text-slate-500 italic text-center" data-id="element-237">
        Note: This will require design + development support for proper
        implementation
      </p>
    </SlideLayout>;
}